module.exports = __webpack_public_path__ + "img/kg_m.c750c633.svg";